import { Actions } from '../../interfaces'
import { Auto } from '@/entities/public'

import find from './find'
import fetch from './fetch'
import create from './create'
import update from './update'

export const actions: Actions = {
  find,
  fetch,
  create,
  update,
}

export default {
  Model: { Auto },
  actions: { [Auto.name]: actions },
}
